<template>
	<FormGroup
		v-if="mounted"
		:add-invalid-class="false"
		class="postal-code-edit"
		feedback-beneath
	>
		<!--<div v-if="characteristic" class="mt-1">
			Ort: {{ postalCode }}<span v-if="characteristic"> - {{ characteristic.label }}</span>
			<a href="#" class="ml-2" @click.prevent="edit">
				<Icon icon="edit"/>
			</a>
		</div>-->
		<div class="postal-code-edit--container">
			<div v-if="withCountrySelection">
				<CountrySelect
					v-model="country"
					:meta="meta"
					empty-option="--- Land wählen ---"
					@input="countryChanged"
				/>
			</div>
			<div v-else>Österreich:</div>
			<FormGroup class="ml-0 ml-md-2 mb-0 flex-grow-1 mt-2 mt-md-0">
				<b-input
					v-if="(withCountrySelection && !country) || unknownCountry"
					v-model="postalCodeFree"
					:disabled="!unknownCountry"
					placeholder="Postleitzahl / Ort eingeben"
					class="postal-code"
					@input="emitChangeEvent"
				/>
				<Dropdown
					v-else
					v-model="postalCodes"
					:custom-options="options"
					:multiple="multiple"
					:coloring="coloring"
					search-type="postal-code-city"
					placeholder="Postleitzahl eingeben"
					@input="emitChangeEvent"
				/>
				<!--<VueSimpleSuggest
					v-else
					v-model="postalCode"
					class="postal-code"
					placeholder="PLZ"
					:list="filteredPostalCodes"
					:debounce="250"
					:min-length="3"
					display-attribute="suggestion"
					:styles="autoCompleteStyle"
					:max-suggestions="0"
					:prevent-submit="false"
					ref="autocomplete"
					@suggestion-click="postalCodeClicked"
				/>-->
			</FormGroup>
		</div>
	</FormGroup>
</template>

<script>
import {isEmptyOrNull} from "@/helper/String";
import {isDefined} from "@/helper/Value";
import FormGroup from "@/vue/common/form/Group";
import Button from "@/vue/common/Button";
import Icon from "@/vue/icon/Icon"
import _ from "lodash";
import SingleSelect from "@/vue/characteristic/SingleSelect";
import CountrySelect from "@/vue/common/form/CountrySelect";
import VueSimpleSuggest from 'vue-simple-suggest'
import Dropdown from "@/vue/characteristic/Dropdown.vue";

const AUSTRIA = 2;

export default {

	components: {
		Dropdown,
		CountrySelect,
		Button,
		FormGroup,
		Icon,
		VueSimpleSuggest,
		SingleSelect,
	},

	props: {
		value: {
			type: Object,
			required: false,
		},
		meta: {
			type: Object,
			required: true,
		},
		disabled: {
			type: Boolean,
			required: false,
			default: false,
		},
		multiple: {
			type: Boolean,
			required: false,
			default: false,
		},
		withCountrySelection: {
			type: Boolean,
			required: false,
			default: false,
		},
		coloring: {
			type: Boolean,
			required: false,
			default: true,
		},
	},

	mounted ()
	{
		if (this.postalCodes)
		{
			let postalCodes = [];

			_.forEach(this.postalCodes, postalCode =>
			{
				postalCodes.push(
					_.find(this.options, option => option.id === postalCode.id)
				);
			});

			this.postalCodes = postalCodes;
		}

		this.emitChangeEvent();

		this.mounted = true;
	},

	data ()
	{
		return {
			country: this.value?.country,
			postalCodes: this.value?.postalCodes,
			postalCodeFree: this.value?.postalCodeFree,
			mounted: false,
		};
	},

	computed: {
		unknownCountry ()
		{
			return isDefined(this.country) && this.country !== AUSTRIA;
		},
		options ()
		{
			const country = this.country || AUSTRIA;

			if (!country)
			{
				return [];
			}

			const countryGroup = _.find(
				this.meta.geoPostalCodeCountryGroups,
				group => group.country.id === country
			);

			return _
				.chain(countryGroup.postalCodes)
				.map(postalCodeItem =>
				{
					return {
						id: postalCodeItem.id,
						postalCode: postalCodeItem.postalCode,
						characteristic: postalCodeItem.characteristic,
						label: postalCodeItem.postalCode + ' - ' + postalCodeItem.characteristic.label
					};
				})
				.value();
		},
		valid ()
		{
			return !this.error;
		},
		error ()
		{
			let error = this.multiple
				? 'Bitte gib deine Postleitzahl(en) ein'
				: 'Bitte gib deine Postleitzahl ein';

			if (this.unknownCountry)
			{
				if (isEmptyOrNull(this.postalCodeFree))
				{
					return error;
				}
			}
			else
			{
				if (!isDefined(this.postalCodes))
				{
					return error;
				}
			}

			return null;
		}
	},

	methods: {
		countryChanged ()
		{
			this.postalCodes = undefined;
			this.postalCodeFree = '';

			this.emitChangeEvent();
		},
		emitChangeEvent ()
		{
			if (!this.valid)
			{
				this.$emit('input', undefined);
				return;
			}

			let data = {};

			if (this.unknownCountry)
			{
				data.country = this.country;
				data.postalCodeFree = this.postalCodeFree;
			}
			else
			{
				data.country = this.withCountrySelection
					? this.country
					: AUSTRIA;
				data.postalCodes = Array.isArray(this.postalCodes)
					? this.postalCodes
					: [ this.postalCodes ];
			}

			this.$emit('input', data);
		}
	}
}
</script>
